import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Chart from "../common/Chart";
import Price from "../common/Price";
import GetInteger from "../../functions/GetInteger";
import DateConverter, {
  formatDateNum,
  formatMonth,
  formatWeek,
} from "../../functions/DateConverter";
function CompPredictSales(props) {
  const { t } = useTranslation();
  const [predictTotal, setPredictTotal] = useState(0);
  const [todayTotal, setTodayTotal] = useState(0);
  const [chartData, setChartData] = useState([]);

  // 날짜나 페이지, 예측치/실제치가 바뀔 때마다 총합을 다시 계산합니다.
  useEffect(() => {
    try {
      const predictValue = props.predictvalue[props.page]["today"];
      setPredictTotal(predictValue);
      setTodayTotal(props.todayValue[props.page]["today"]);
    } catch (error) {}
  }, [props.page, props.predictvalue, props.todayValue]);

  // predictTotal, todayTotal, 번역 함수(t)가 바뀔 때마다 차트 데이터를 업데이트합니다.
  useEffect(() => {
    setChartData([
      {
        column: t("compPredictSales.expectedRevenue"),
        value: predictTotal,
        highlight: false,
        valueHighlight: false,
      },
      {
        column: t("compPredictSales.actualRevenue"),
        value: todayTotal,
        highlight: true,
        valueHighlight: true,
      },
    ]);
  }, [predictTotal, todayTotal, t]);

  const diff = todayTotal - predictTotal;
  const todayValue = props?.value[props.page]?.today ?? 0;
  const nextValue = props?.value[props.page]?.tomorrow ?? 0;
  const compareValue = props?.rankCompareValue[props.page] ?? {};
  const menuObject = props.menuObject;
  let data = [];
  let profit = 0;

  const getNextDate = (currentDate) => {
    let date = new Date(currentDate); // 현재 날짜를 Date 객체로 변환
    date.setDate(date.getDate() + 1); // 하루 추가
    return date.toISOString().split("T")[0]; // YYYY-MM-DD 형식으로 변환
  };

  const getNextWeek = (currentDate) => {
    let date = new Date(currentDate); // 현재 날짜를 Date 객체로 변환
    date.setDate(date.getDate() + 7); // 하루 추가
    return date.toISOString().split("T")[0]; // YYYY-MM-DD 형식으로 변환
  };

  const getNextMonth = (currentDate) => {
    let date = new Date(currentDate);
    date.setDate(date.getDate() + 30); // 추후 변경 필요
    return date.toISOString().split("T")[0];
  };

  const getAverage = () => {
    if (data.length === 0) return 0;
    let sum = 0;
    for (let salesData of data) {
      sum += salesData.value;
    }
    return GetInteger(sum / data.length);
  };

  for (const dates of Object.keys(compareValue).reverse().slice(-4)) {
    if (compareValue[dates].length !== 0) {
      profit = compareValue[dates];

      const obj = {
        column:
          props.page === "daily"
            ? `${formatDateNum(dates)} `
            : props.page === "weekly"
            ? `${formatWeek(dates)} `
            : props.page === "monthly"
            ? `${formatMonth(dates)} `
            : "",
        value: GetInteger(profit / 10000),
        highlight: false,
        valueHighlight: false,
      };
      data.push(obj);
    }
  }

  profit = todayValue;

  let obj = {
    column:
      props.page === "daily"
        ? `${formatDateNum(props.currentDate)}`
        : props.page === "weekly"
        ? `${formatWeek(props.currentDate)}`
        : props.page === "monthly"
        ? `${formatMonth(props.currentDate)}`
        : "",
    value: profit,
    highlight: false,
    valueHighlight: false,
  };
  data.push(obj);

  profit = nextValue;

  obj = {
    column:
      props.page === "daily"
        ? `${formatDateNum(getNextDate(props.currentDate))}`
        : props.page === "weekly"
        ? `${formatWeek(getNextWeek(props.currentDate))}`
        : props.page === "monthly"
        ? `${formatMonth(getNextMonth(props.currentDate))}`
        : "",
    value: profit,
    highlight: true,
    valueHighlight: false,
  };
  data.push(obj);

  let avg = getAverage();
  const formattedAvg = avg.toLocaleString("ko-KR");
  return (
    <div className="block w-[100%] px-[5%] pt-10 pb-4 border border-[#f3f4f6] font-semibold text-[5.7vw]">
      {diff > 0 ? (
        <div className="font-semibold text-[5.7vw]">
          <div>
            {props.page === "daily"
              ? t("compPredictSales.todaySales")
              : props.page === "weekly"
              ? t("compPredictSales.thisWeekSales")
              : props.page === "monthly"
              ? t("compPredictSales.thisMonthSales")
              : t("compPredictSales.todaySales")}{" "}
            😆
          </div>
          <div className="flex flex-col">
            <Price value={diff} unit={t("compPredictSales.unit")} style={800} />
            {t("compPredictSales.moreEarned")}
          </div>
        </div>
      ) : diff < 0 ? (
        <div className="font-semibold text-[5.7vw]">
          <div>
            {props.page === "daily"
              ? t("compPredictSales.todaySales")
              : props.page === "weekly"
              ? t("compPredictSales.thisWeekSales")
              : props.page === "monthly"
              ? t("compPredictSales.thisMonthSales")
              : t("compPredictSales.todaySales")}
          </div>
          <div className="flex flex-col">
            <Price
              value={-diff}
              unit={t("compPredictSales.unit")}
              style={800}
            />
            {t("compPredictSales.lessEarned")}
          </div>
        </div>
      ) : (
        <div className="font-semibold text-[5.7vw]">
          <div>
            {props.page === "daily"
              ? t("compPredictSales.sameDaySales")
              : props.page === "weekly"
              ? t("compPredictSales.sameWeekSales")
              : props.page === "monthly"
              ? t("compPredictSales.sameMonthSales")
              : t("compPredictSales.todaySales")}
          </div>
          <div className="font-extrabold">
            {t("compPredictSales.sameEarned")}
          </div>
        </div>
      )}
      <div className="pt-10">
        <div className="block w-[100%] px-[5%]  text-black font-semibold text-[5.7vw]">
          <div className="flex justify-center text-[3.5vw] font-normal">
            {props.page === "daily"
              ? `${props.t(
                  "predictSales.average.daily.first"
                )} ${formattedAvg}${props.t(
                  "predictSales.average.daily.second"
                )}`
              : props.page === "weekly"
              ? `${props.t(
                  "predictSales.average.weekly.first"
                )} ${formattedAvg}${props.t(
                  "predictSales.average.weekly.second"
                )}`
              : props.page === "monthly"
              ? `${props.t(
                  "predictSales.average.monthly.first"
                )} ${formattedAvg}${props.t(
                  "predictSales.average.monthly.second"
                )}`
              : ""}
          </div>
        </div>
        <Chart isVisible={props.isVisible} type="bar" data={chartData} />
      </div>
    </div>
  );
}

export default CompPredictSales;
